/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Annual Security Incident
 * Report Form
 *
 * Includes the ff:
 * - name, collection name, label and other static values for the table
 * - Data view for fetching different formatted data from the server
 * - Route definitions for different actions within the table
 * - Binded varibles
 * - Name of the privilege for role restrictions
 * - Name of table columns/headers indicated as field
 * - Action buttons on top of the table indicAted as tableActions
 * - Action buttons per item inside the tableAindicated as entryActions
 * - Different header config for tabs per user roles
 */
export default function (vm) {
  return {
    name: 'SecurityIncidentTable',
    collectionName: 'SecurityIncident',
    dataView: 'table',
    label: 'Annual Security Incident Report',
    tableHeader: 'Annual Security Incident Report',
    route: {
      updateMultiple: 'asir',
      list: 'asir',
      deleteMultiple: 'asir',
      upload: 'asir',
      viewMyProfile: 'user/myprofile'
    },
    vBind: {
      singleSelect: true
    },
    // advancedQuery: {
    //   type: 'securityIncident'
    // },
    showExpand: true,
    singleExpand: true,
    hideSelect: true,
    privilege: 'canViewAllAsir',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'PIC',
          value: 'pic'
        }
      },
      {
        columnHeader: {
          sortable: true,
          text: 'Year',
          value: 'year'
        }
      },
      {
        columnHeader: {
          sortable: true,
          text: 'Sector Name',
          value: 'sectorName'
        }
      },
      {
        columnHeader: {
          sortable: true,
          text: 'Sub Sector Name',
          value: 'subSectorName'
        }
      },
      {
        columnHeader: {
          sortable: true,
          text: 'City / Municipality',
          value: 'city'
        }
      },
      {
        columnHeader: {
          sortable: true,
          text: 'Status',
          value: 'status',
          align: 'center'
        }
      }
    ],
    expandHeaders: [
      'Status',
      'Date and Time',
      'Modified By'
    ],
    tableActions: [
      {
        id: 'create',
        label: 'create',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostAsir',
        action: () => {
          vm.$router.push({
            name: 'SecurityIncidentCreate',
            params: {
              dataTab: 'asir',
              operation: 'create'
            }
          })
        }
      },
      {
        id: 'deadline',
        label: 'deadline',
        icon: 'mdi-clock-outline',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPatchDeadline',
        action: () => {
          vm.openDeadline()
        }
      }
    ],
    entryActions: [
      {
        id: 'delete',
        icon: 'mdi-delete',
        privilege: 'canDeleteAsir'
      },
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewAsir',
        action: (item) => {
          vm.$router.push({
            name: 'SecurityIncidentView',
            params: {
              dataTab: 'asir',
              operation: 'view',
              id: item._id
            }
          })
        }
      }
    ],
    queryTabs: [],
    'all-query': {
      status: { $ne: 'Drafted' }
    },
    headerKeys: {
      pic: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.pic)),
        items: vm.allItems.map(item => item.pic)
      },
      year: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.year)),
        items: vm.allItems.map(item => item.year)
      },
      sectorName: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.sectorName)),
        items: vm.allItems.map(item => item.sectorName)
      },
      subSectorName: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.subSectorName[0])),
        items: vm.allItems.map(item => item.subSectorName[0])
      },
      status: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.status)),
        items: vm.allItems.map(item => item.status)
      },
      city: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.city.toUpperCase())),
        items: vm.allItems.map(item => item.city.toUpperCase())
      }
    }
  }
}
